module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Tools/Angle Grinder-280906d91d0b34684fddf407da407de5.svg";